// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table_tbody__T3at6 td {
  word-break: break-word !important;
  padding: 10px 5px;
  font-size: 13px;
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  border: none !important;
  text-align: start;
  vertical-align: middle !important;
}
.Table_tbody__T3at6 tr {
  border-top: 1px solid #f6f6f6;
}
.Table_tbody__T3at6 tr td:first-child {
  padding-left: 30px !important;
}
.Table_tbody__T3at6 tr td:last-child {
  padding-right: 30px !important;
}

.Table_clickable__moguo {
  cursor: pointer;
}

.Table_thead__fzlJU th {
  color: #758282;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  background-color: #f6f6f6 !important;
  border: none !important;
  text-align: start;
}
.Table_thead__fzlJU th.Table_sortable__QDOjN {
  cursor: pointer;
}
.Table_thead__fzlJU tr th:first-child {
  padding-left: 30px !important;
}
.Table_thead__fzlJU tr th:last-child {
  padding-right: 30px !important;
}

.Table_table_container__72zic {
  background-color: unset;
}
@media (max-width: 1400px) {
  .Table_table_container__72zic {
    overflow: auto;
  }
}
.Table_table_container__72zic tr {
  cursor: pointer;
}
.Table_table_container__72zic::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.Table_table_container__72zic::-webkit-scrollbar-track {
  background: transparent;
}
.Table_table_container__72zic::-webkit-scrollbar-thumb {
  background-color: #E7E7E7;
  border-radius: 20px;
}
.Table_table_content__Vs5X1 {
  border-collapse: collapse;
  margin-bottom: 0;
}
@media (max-width: 1200px) {
  .Table_table_content__Vs5X1 {
    white-space: nowrap;
  }
}
.Table_table__sorting__ohLnv {
  display: flex;
  align-items: flex-start;
  line-height: 1;
}
.Table_table__sorting-icon__f3wLi svg {
  stroke: #899696;
}
.Table_table__sorting-icon--active__vsPCH svg {
  stroke: #242424;
}
.Table_table__sorting-icon--desc__Kwb\\+R {
  transform: rotate(180deg);
}

.Table_tbody__T3at6 tr:last-child {
  border-bottom-color: #fff;
}

.Table_tfoot__cNu3R td {
  border: none !important;
  padding: 0 !important;
}

.Table_wrap__o-UxS {
  background-color: #fff;
  padding-bottom: 5px;
  border-radius: 0 0 10px 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/UI/Table/Table.module.scss"],"names":[],"mappings":"AACE;EACE,iCAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,iCAAA;AAAJ;AAGE;EACE,6BAAA;AADJ;AAGI;EACE,6BAAA;AADN;AAII;EACE,8BAAA;AAFN;;AAOA;EACE,eAAA;AAJF;;AASE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;EACA,uBAAA;EACA,iBAAA;AANJ;AAQI;EACE,eAAA;AANN;AAWI;EACE,6BAAA;AATN;AAYI;EACE,8BAAA;AAVN;;AAgBE;EACE,uBAAA;AAbJ;AAeI;EAHF;IAII,cAAA;EAZJ;AACF;AAcI;EACE,eAAA;AAZN;AAeI;EACE,UAAA;EACA,WAAA;AAbN;AAgBI;EACE,uBAAA;AAdN;AAiBI;EACE,yBAAA;EACA,mBAAA;AAfN;AAmBE;EACE,yBAAA;EACA,gBAAA;AAjBJ;AAmBI;EAJF;IAKI,mBAAA;EAhBJ;AACF;AAoBE;EACE,aAAA;EACA,uBAAA;EACA,cAAA;AAlBJ;AAqBM;EACE,eAAA;AAnBR;AAuBQ;EACE,eAAA;AArBV;AAyBM;EACE,yBAAA;AAvBR;;AA8BE;EACE,yBAAA;AA3BJ;;AAgCE;EACE,uBAAA;EACA,qBAAA;AA7BJ;;AAkCA;EACE,sBAAA;EACA,mBAAA;EACA,4BAAA;AA/BF","sourcesContent":[".tbody {\n  & td {\n    word-break: break-word !important;\n    padding: 10px 5px;\n    font-size: 13px;\n    font-family: Inter;\n    font-style: normal;\n    font-weight: 400;\n    border: none !important;\n    text-align: start;\n    vertical-align: middle !important;\n  }\n\n  & tr {\n    border-top: 1px solid #f6f6f6;\n\n    & td:first-child {\n      padding-left: 30px !important;\n    }\n\n    & td:last-child {\n      padding-right: 30px !important;\n    }\n  }\n}\n\n.clickable {\n  cursor: pointer;\n\n}\n\n.thead {\n  & th {\n    color: #758282;\n    font-family: Inter;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    background-color: #f6f6f6 !important;\n    border: none !important;\n    text-align: start;\n\n    &.sortable {\n      cursor: pointer;\n    }\n  }\n\n  & tr {\n    & th:first-child {\n      padding-left: 30px !important;\n    }\n\n    & th:last-child {\n      padding-right: 30px !important;\n    }\n  }\n}\n\n.table {\n  &_container {\n    background-color: unset;\n\n    @media (max-width: 1400px) {\n      overflow: auto;\n    }\n\n    tr {\n      cursor: pointer;\n    }\n\n    &::-webkit-scrollbar {\n      width: 5px;\n      height: 5px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: transparent;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background-color: #E7E7E7;\n      border-radius: 20px;\n    }\n  }\n\n  &_content {\n    border-collapse: collapse;\n    margin-bottom: 0;\n\n    @media (max-width: 1200px) {\n      white-space: nowrap;\n    }\n\n  }\n\n  &__sorting {\n    display: flex;\n    align-items: flex-start;\n    line-height: 1;\n\n    &-icon {\n      svg {\n        stroke: #899696;\n      }\n\n      &--active {\n        svg {\n          stroke: #242424;\n        }\n      }\n\n      &--desc {\n        transform: rotate(180deg);\n      }\n    }\n  }\n}\n\n.tbody {\n  & tr:last-child {\n    border-bottom-color: #fff;\n  }\n}\n\n.tfoot {\n  & td {\n    border: none !important;\n    padding: 0 !important;\n  }\n\n}\n\n.wrap {\n  background-color: #fff;\n  padding-bottom: 5px;\n  border-radius: 0 0 10px 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tbody": `Table_tbody__T3at6`,
	"clickable": `Table_clickable__moguo`,
	"thead": `Table_thead__fzlJU`,
	"sortable": `Table_sortable__QDOjN`,
	"table_container": `Table_table_container__72zic`,
	"table_content": `Table_table_content__Vs5X1`,
	"table__sorting": `Table_table__sorting__ohLnv`,
	"table__sorting-icon": `Table_table__sorting-icon__f3wLi`,
	"table__sorting-icon--active": `Table_table__sorting-icon--active__vsPCH`,
	"table__sorting-icon--desc": `Table_table__sorting-icon--desc__Kwb+R`,
	"tfoot": `Table_tfoot__cNu3R`,
	"wrap": `Table_wrap__o-UxS`
};
export default ___CSS_LOADER_EXPORT___;
